import React from 'react';
import { TableCell, Box } from '@mui/material';

const GridImagePreviewCell = ({ value, field, ...other }) => {
    if (!value) return (
        <TableCell key={field.id} align="left">
            -
        </TableCell>
    );

    return (
        <TableCell key={field.id} align="left">
            <Box
                display="flex"
                alignItems="center"
            >
                <img
                    loading="lazy"
                    src={value}
                    alt="Campaign Preview"
                    style={{
                        width: '48px',
                        height: '48px',
                        objectFit: 'cover',
                        borderRadius: '8px',
                        border: '1px solid #e0e0e0'
                    }}
                    onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentNode.innerHTML = 'No Image';
                    }}
                />
            </Box>
        </TableCell>
    );
};

export default GridImagePreviewCell; 